/**
 * @generated SignedSource<<ea42ed605d1cadf35f86d3580bf60859>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type view_issueViewCommonViews_ChildIssuePanelBaseWithIssueSearchTotalCount$data = {
  readonly issueSearch?: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "view_issueViewCommonViews_ChildIssuePanelBaseWithIssueSearchTotalCount";
};
export type view_issueViewCommonViews_ChildIssuePanelBaseWithIssueSearchTotalCount$key = {
  readonly " $data"?: view_issueViewCommonViews_ChildIssuePanelBaseWithIssueSearchTotalCount$data;
  readonly " $fragmentSpreads": FragmentRefs<"view_issueViewCommonViews_ChildIssuePanelBaseWithIssueSearchTotalCount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmagma3191renderchinskeletoninssrrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    }
  ],
  "kind": "Fragment",
  "name": "view_issueViewCommonViews_ChildIssuePanelBaseWithIssueSearchTotalCount",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmagma3191renderchinskeletoninssrrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Variable",
              "name": "fieldSetsInput",
              "variableName": "fieldSetsInput"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            }
          ],
          "concreteType": "JiraIssueConnection",
          "kind": "LinkedField",
          "name": "issueSearch",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "totalCount"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "4c6f88cd67e59ad1c5d609efb743f3b0";

export default node;
